/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import MyAccount from './components/MyAccount';
import { getAppRoutePrefix } from '../../helpers/common/helper';

const appRouterPrefix = getAppRoutePrefix()

const Routes = ({ isUsingMFE }) => {
    return (
        <>
            <Switch>
                <Route
                    path={`${appRouterPrefix}/account/gift-list/:id?`}
                    exact
                    component={() => <MyAccount page={{ account: true }} module="GiftList" isUsingMFE={isUsingMFE} />}
                />
                {/* H&D */}
                <Route
                    path={`${appRouterPrefix}/gifthistory-home-gift-baskets/:params?`}
                    component={() => <MyAccount page={{ account: true }} module="GiftList" isUsingMFE={isUsingMFE} />}
                />
                {/* CCO */}
                <Route
                    path={`${appRouterPrefix}/gifthistory-home-cookies/:params?`}
                    component={() => <MyAccount page={{ account: true }} module="GiftList" isUsingMFE={isUsingMFE} />}
                />
                {/* STY */}
                <Route
                    path={`${appRouterPrefix}/gifthistory-home-steaks/:params?`}
                    component={() => <MyAccount page={{ account: true }} module="GiftList" isUsingMFE={isUsingMFE} />}
                />
                {/* WLF */}
                <Route
                    path={`${appRouterPrefix}/gifthistory-home-bakery/:params?`}
                    component={() => <MyAccount page={{ account: true }} module="GiftList" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/orders/:uuid/:order/:zipcode?/:billingzipcode?`}
                    exact
                    component={() => <MyAccount page={{ account: true }} module="OrderDetails" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/orders`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'ordertracking' }} module="TrackOrder" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/guest-started`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'guestreminders' }} usUsingMFE={isUsingMFE} module="CelebrationsRemindersPage" />}
                />
                <Route
                    path={`${appRouterPrefix}/account/floraverse`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'Floraverse' }} module="FloraVerse" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/momverse`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'Momverse' }} module="PoemPage" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/dadjokegpt`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'DadJokeGPT' }} module="PoemPage" isUsingMFE={isUsingMFE} isDadJokeGPT />}
                />
                <Route
                    path={`${appRouterPrefix}/account/vday-playbook`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'PlayBook' }} module="PlayBook" />}
                />
                <Route
                    path={`${appRouterPrefix}/account/thankyoucards/:params?`}
                    exact
                    component={() => <MyAccount page={{ account: true, type: 'recipientverify' }} module="RecipientVerify" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/subscriptions`}
                    component={() => <MyAccount page={{ account: true }} module="Subscriptions" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/address-book/:rcpId/:occasionId?`}
                    component={() => <MyAccount page={{ account: true, type: 'editRecipientBook' }} module="EditRecipientContainer" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/address-book`}
                    component={() => <MyAccount page={{ account: true, type: 'addressbook' }} module="AddressBookContainer" isUsingMFE={isUsingMFE} />}
                />
                <Route
                    path={`${appRouterPrefix}/account/reminders/opt-out`}
                    component={() => <MyAccount page={{ account: true, type: 'remindersOptOut' }} module="RemindersOptOutPage" />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/billing-address`}
                    component={() => <MyAccount page={{ account: true, type: 'billingaddress' }} module="BillingAddress" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/profile`}
                    component={() => <MyAccount page={{ account: true, type: 'accountprofile' }} module="ProfileAndPassword" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/change-password`}
                    component={() => <MyAccount page={{ account: true }} module="ChangePassword" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/change-email`}
                    component={() => <MyAccount page={{ account: true }} module="ChangeEmail" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/email-preference`}
                    component={() => <MyAccount page={{ account: true, type: 'emailpreference' }} module="EmailPreferenceContainer" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account/passport`}
                    component={() => <MyAccount page={{ account: true }} module="Passport" isUsingMFE={isUsingMFE} />}
                />
                <ProtectedRoute
                    path={`${appRouterPrefix}/account`}
                    component={() => <MyAccount page={{ account: true, type: 'myaccount' }} module="AccountHome" isUsingMFE={isUsingMFE} />}
                />
            </Switch>
        </>
    );
}


export default Routes;
